import React from "react";
import Myrow from "../../fastparity/order/Myrow";

const Myorder1 = ({ biddataparity }) => {
  return (
    <>  
      <table className="table-everyone-order">
        <tr className="table-everyone-order-heading">
          <td className="text-align-tb">Period</td>
          <td>Select</td>
          <td className="text-align-tb">Point</td>
          <td>Result</td>
          <td className="text-align-tb">Amount</td>
        </tr>


        {biddataparity &&
          biddataparity.map((item) => {
            return (
              <>
                <Myrow
                  period={item.period}
                  bgcolor={item.result_color}
                  numresult={item.number_result}
                  totalamount={item.total_amount}
                  selected={item.bid}
                />
              </>
            );
          })}
      </table>
    </>
  );
};

export default Myorder1;
